import { HttpBackend, HttpClient } from '@angular/common/http';
import { LanguageLoaderBase, LanguageOptions } from '@igo2/core/language';
import { ObjectUtils } from '@igo2/utils';

import {
  BehaviorSubject,
  Observable,
  forkJoin,
  map,
  of,
  tap
} from 'rxjs';

export class NoCacheLanguageLoader implements LanguageLoaderBase {
  private httpClient: HttpClient;

  private _isLoaded$ = new BehaviorSubject<boolean>(null);
  isLoaded$ = this._isLoaded$.asObservable();

  suffix = '.json';
  prefix?: string | string[];
  options: LanguageOptions;

  constructor(handler: HttpBackend, options: LanguageOptions) {
    this.httpClient = new HttpClient(handler);
    this.options = options;
  }

  public getTranslation(lang: string): Observable<any> {
    const igoLocale$ = this.httpClient.get(`locale/libs_locale/${lang}.json`);
    if (!this.prefix) {
      const prefix = this.options.prefix;
      this.prefix = !prefix || Array.isArray(prefix) ? prefix : [prefix];
    }

    if (!this.prefix || this.prefix.length === 0) {
      this._isLoaded$.next(true);
      return this.options.ignoreLibsLocale ? of(undefined) : igoLocale$;
    }

    const timestamp = new Date().getTime();
    const appLocale$ = (this.prefix as string[]).map((prefix) =>
      this.httpClient.get(`${prefix}${lang}${this.suffix}?datetime=${timestamp}`)  //<-- tout ça pour ça.
    );

    const locale$ = [...appLocale$];

    if (!this.options.ignoreLibsLocale) {
      locale$.unshift(igoLocale$);
    }

    return forkJoin(locale$).pipe(
      map((translations) => {
        return translations.reduce(
          (acc, current) => ObjectUtils.mergeDeep(acc, current),
          {}
        );
      }),
      tap(() => {
        this._isLoaded$.next(true);
      })
    );
  }
}
